<template>
  <div class="content-wrapper">
    <page-header
      screen-name="Cadastrar Novo"
      :link-items="linkItems"
    />

    <Form mode="insert" />
  </div>
</template>

<script>

import PageHeader from '@/views/components/custom/page-header/PageHeader.vue'
import Form from '@/views/custom-pages/gerenciarUsuarios/usuarioAdministrativo/Form.vue'

export default {
  title: 'Cadastrar usuário',

  components: {
    PageHeader,
    Form,
  },

  data() {
    return {
      linkItems: [
        {
          name: 'Gerenciar usuários',
          routeName: 'usuario-list',
        },
        {
          name: 'Cadastrar Novo',
          active: true,
        },
      ],
    }
  },

  mounted() {
    this.$store.commit('adminUserState/clearFormData')
  },
}
</script>
